<template>
  <div class="cases-page">
    <!-- 页面标题区域 -->
    <section class="page-title">
      <div class="container">
        <h1>健康服务案例</h1>
        <p>专业医疗服务的成功实践</p>
      </div>
    </section>

    <!-- 行业筛选 -->
    <section class="industry-filter">
      <div class="container">
        <div class="filter-tabs">
          <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
            <el-tab-pane label="全部案例" name="all"></el-tab-pane>
            <el-tab-pane label="企业健康管理" name="corporate"></el-tab-pane>
            <el-tab-pane label="体检中心建设" name="physical"></el-tab-pane>
            <el-tab-pane label="慢病管理" name="chronic"></el-tab-pane>
            <el-tab-pane label="远程医疗" name="telemedicine"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </section>

    <!-- 案例展示 -->
    <section class="cases-showcase">
      <div class="container">
        <div class="cases-grid">
          <div
            class="case-card"
            v-for="(caseItem, index) in filteredCases"
            :key="index"
            @click="viewCaseDetail(caseItem.id)">
            <div class="case-image">
              <img :src="caseItem.image" :alt="caseItem.title" />
            </div>
            <div class="case-info">
              <div class="case-industry">{{ caseItem.industry }}</div>
              <h3 class="case-title">{{ caseItem.title }}</h3>
              <p class="case-summary">{{ caseItem.summary }}</p>
              <div class="case-footer">
                <span class="case-date">{{ caseItem.date }}</span>
                <span class="view-detail"
                  >查看详情 <i class="el-icon-arrow-right"></i
                ></span>
              </div>
            </div>
          </div>
        </div>

        <!-- 无内容提示 -->
        <div v-if="filteredCases.length === 0" class="no-data">
          <el-empty description="暂无相关案例"></el-empty>
        </div>

        <!-- 分页 -->
        <div v-if="filteredCases.length > 0" class="pagination">
          <el-pagination
            layout="prev, pager, next"
            :total="filteredCases.length"
            :page-size="6"
            @current-change="handleCurrentChange"></el-pagination>
        </div>
      </div>
    </section>

    <!-- 成功案例分析 -->
    <section class="case-analysis">
      <div class="container">
        <div class="section-title">
          <h2>案例分析</h2>
          <p>深入了解我们的解决方案如何帮助客户</p>
        </div>

        <div class="analysis-content">
          <div class="analysis-item">
            <div class="analysis-image">
              <img
                src="https://picsum.photos/id/239/600/400"
                alt="健康管理案例分析" />
            </div>
            <div class="analysis-text">
              <h3>某大型企业员工健康管理综合解决方案</h3>
              <p>
                我们为某大型企业提供了全方位的员工健康管理解决方案，包括健康体检、健康风险评估、慢病干预、
                健康讲座和心理咨询等服务。通过一年的实施，员工健康风险下降35%，人均医疗费用减少28%，
                员工满意度提升至95%。本案例详细介绍了我们如何根据企业特点定制服务方案，以及实施过程中的关键措施和成效。
              </p>
              <ul class="analysis-points">
                <li>• 个性化健康体检套餐设计</li>
                <li>• 健康风险评估与干预</li>
                <li>• 企业健康文化建设</li>
                <li>• 数据化健康管理平台</li>
              </ul>
              <el-button type="primary" class="analysis-btn"
                >查看完整报告</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 客户评价轮播 -->
    <section class="customer-testimonials">
      <div class="container">
        <div class="section-title">
          <h2>客户评价</h2>
          <p>来自我们客户的真实反馈</p>
        </div>

        <div class="testimonials-slider">
          <el-carousel type="card" height="300px">
            <el-carousel-item
              v-for="(testimonial, index) in testimonials"
              :key="index">
              <div class="testimonial-content">
                <p class="testimonial-text">{{ testimonial.quote }}</p>
                <div class="testimonial-author">
                  <img :src="testimonial.avatar" :alt="testimonial.name" />
                  <div class="author-info">
                    <h4>{{ testimonial.name }}</h4>
                    <p>
                      {{ testimonial.position }} - {{ testimonial.company }}
                    </p>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </section>

    <!-- 客户合作咨询 -->
    <section class="cooperation-consult">
      <div class="container">
        <div class="consult-content">
          <h2>需要定制化的健康服务方案？</h2>
          <p>填写咨询表单，我们的健康顾问将为您提供专业的解决方案</p>
          <el-button type="primary" size="large">立即咨询</el-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Cases",
  components: {},
  data() {
    return {
      activeTab: "all",
      currentPage: 1,
      cases: [
        {
          id: 1,
          title: "跨国企业员工健康管理项目",
          summary:
            "为某跨国企业提供定制化员工健康管理服务，包括年度体检、健康风险评估、慢病干预等，员工健康水平提升30%。",
          image: "https://picsum.photos/id/237/600/400",
          industry: "企业健康管理",
          date: "2023-10-15",
        },
        {
          id: 2,
          title: "高端体检中心智能化升级",
          summary:
            "为某高端体检中心实施智能化升级，引入AI辅助诊断系统和智能排队系统，客户满意度提升至98%。",
          image: "https://picsum.photos/id/493/600/400",
          industry: "体检中心建设",
          date: "2023-09-20",
        },
        {
          id: 3,
          title: "高血压慢病管理示范项目",
          summary:
            "与社区医疗机构合作开展高血压慢病管理项目，通过远程监测和个性化干预方案，患者血压达标率提升45%。",
          image: "https://picsum.photos/id/655/600/400",
          industry: "慢病管理",
          date: "2023-08-12",
        },
        {
          id: 4,
          title: "远程医疗服务平台建设",
          summary:
            "为偏远地区医疗机构构建远程医疗服务平台，实现优质医疗资源下沉，服务覆盖10万余人口。",
          image: "https://picsum.photos/id/239/600/400",
          industry: "远程医疗",
          date: "2023-07-30",
        },
        {
          id: 5,
          title: "国企员工健康管理体系构建",
          summary:
            "为某大型国有企业构建完整的员工健康管理体系，建立健康档案、开展健康讲座、提供心理咨询等全方位服务。",
          image: "https://picsum.photos/id/338/600/400",
          industry: "企业健康管理",
          date: "2023-06-18",
        },
        {
          id: 6,
          title: "社区体检中心标准化建设",
          summary:
            "按照国际标准为社区体检中心提供整体解决方案，包括流程设计、设备配置、人员培训等。",
          image: "https://picsum.photos/id/433/600/400",
          industry: "体检中心建设",
          date: "2023-05-25",
        },
        {
          id: 7,
          title: "糖尿病管理云平台",
          summary:
            "开发糖尿病管理云平台，整合血糖监测、饮食指导、运动建议等功能，患者自我管理能力显著提升。",
          image: "https://picsum.photos/id/349/600/400",
          industry: "慢病管理",
          date: "2023-04-10",
        },
        {
          id: 8,
          title: "互联网医院远程会诊系统",
          summary:
            "为互联网医院建设远程会诊系统，实现多学科专家联合诊疗，年服务患者超过5万人次。",
          image: "https://picsum.photos/id/152/600/400",
          industry: "远程医疗",
          date: "2023-03-05",
        },
      ],
      testimonials: [
        {
          quote:
            "康泰医疗提供的企业健康管理服务让我们的员工健康状况得到了显著改善，员工满意度和工作效率都有很大提升。专业的医疗团队和贴心的服务让我们非常满意。",
          name: "张伟",
          position: "人力资源总监",
          company: "某大型科技企业",
          avatar: "https://picsum.photos/id/1012/100/100",
        },
        {
          quote:
            "作为社区医疗机构，与康泰医疗合作的慢病管理项目让我们的服务能力得到了极大提升。他们提供的专业指导和技术支持帮助我们更好地为社区居民服务。",
          name: "王丽",
          position: "社区卫生服务中心主任",
          company: "某社区卫生服务中心",
          avatar: "https://picsum.photos/id/1005/100/100",
        },
        {
          quote:
            "康泰医疗帮助我们建设的远程医疗平台解决了我们地区医疗资源匮乏的问题，让当地居民能够便捷地享受到优质的医疗服务。这是一项真正惠及民生的工程。",
          name: "李华",
          position: "医院院长",
          company: "某县级医院",
          avatar: "https://picsum.photos/id/1027/100/100",
        },
      ],
    };
  },
  computed: {
    // 根据选中的行业筛选案例
    filteredCases() {
      if (this.activeTab === "all") {
        return this.cases;
      }

      // 根据行业映射进行筛选
      const industryMap = {
        corporate: "企业健康管理",
        physical: "体检中心建设",
        chronic: "慢病管理",
        telemedicine: "远程医疗",
      };

      return this.cases.filter(
        (item) => item.industry === industryMap[this.activeTab]
      );
    },
  },
  watch: {},
  created() {},
  methods: {
    // 切换标签页
    handleTabClick(tab) {
      this.activeTab = tab.name;
      this.currentPage = 1;
    },

    // 查看案例详情
    viewCaseDetail(id) {
      // 这里可以跳转到案例详情页
      console.log("查看案例详情:", id);
      // 示例: this.$router.push(`/cases/detail/${id}`);
    },

    // 分页切换
    handleCurrentChange(page) {
      this.currentPage = page;
    },
  },
};
</script>

<style scoped lang="less">
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 页面标题样式 */
.page-title {
  background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
  color: #fff;
  padding: 100px 0;
  text-align: center;

  h1 {
    font-size: 48px;
    margin-bottom: 20px;
    font-weight: 600;
  }

  p {
    font-size: 20px;
    opacity: 0.9;
  }
}

/* 行业筛选样式 */
.industry-filter {
  padding: 40px 0;
  background: #fafafa;

  .filter-tabs {
    .el-tabs__header {
      margin: 0;

      .el-tabs__nav {
        width: 100%;
        display: flex;
        justify-content: center;

        .el-tabs__item {
          padding: 0 30px;
          font-size: 16px;

          &.is-active {
            color: #1890ff;
          }
        }

        .el-tabs__active-bar {
          background-color: #1890ff;
        }
      }
    }
  }
}

/* 案例展示样式 */
.cases-showcase {
  padding: 80px 0;

  .cases-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    margin-bottom: 60px;
  }

  .case-card {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 8px 24px rgba(24, 144, 255, 0.15);
    }

    .case-image {
      height: 220px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;

        &:hover {
          transform: scale(1.05);
        }
      }
    }

    .case-info {
      padding: 25px;
    }

    .case-industry {
      display: inline-block;
      background: #e6f7ff;
      color: #1890ff;
      padding: 5px 12px;
      border-radius: 20px;
      font-size: 12px;
      margin-bottom: 15px;
    }

    .case-title {
      font-size: 20px;
      color: #333;
      margin-bottom: 15px;
      font-weight: 600;
      line-height: 1.4;
    }

    .case-summary {
      font-size: 14px;
      color: #666;
      line-height: 1.6;
      margin-bottom: 20px;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .case-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .case-date {
        font-size: 12px;
        color: #999;
      }

      .view-detail {
        font-size: 14px;
        color: #1890ff;
        display: flex;
        align-items: center;

        i {
          margin-left: 5px;
          font-size: 12px;
        }

        &:hover {
          color: #40a9ff;
        }
      }
    }
  }

  /* 无数据提示 */
  .no-data {
    padding: 80px 0;
    text-align: center;
  }

  /* 分页样式 */
  .pagination {
    text-align: center;

    .el-pagination {
      display: inline-block;

      .el-pager li {
        &.active {
          color: #1890ff;
          font-weight: 600;
        }
      }

      .el-pagination__prev,
      .el-pagination__next {
        color: #606266;

        &.is-disabled {
          color: #c0c4cc;
        }
      }
    }
  }
}

/* 案例分析样式 */
.case-analysis {
  padding: 100px 0;
  background: #f5f0ff;

  .section-title {
    text-align: center;
    margin-bottom: 60px;

    h2 {
      font-size: 36px;
      color: #333;
      margin-bottom: 15px;
      position: relative;
      display: inline-block;

      &::after {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 80px;
        height: 3px;
        background: #1890ff;
      }
    }

    p {
      font-size: 18px;
      color: #666;
    }
  }

  .analysis-content {
    .analysis-item {
      background: #fff;
      border-radius: 12px;
      overflow: hidden;
      display: flex;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);

      .analysis-image {
        flex: 0 0 45%;
        height: 400px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .analysis-text {
        flex: 1;
        padding: 50px;
        display: flex;
        flex-direction: column;

        h3 {
          font-size: 28px;
          color: #333;
          margin-bottom: 20px;
          font-weight: 600;
        }

        p {
          font-size: 16px;
          color: #666;
          line-height: 1.8;
          margin-bottom: 25px;
        }

        .analysis-points {
          margin-bottom: 30px;

          li {
            font-size: 14px;
            color: #666;
            line-height: 1.8;
            margin-bottom: 10px;
          }
        }

        .analysis-btn {
          margin-top: auto;
          background: #1890ff;
          border-color: #1890ff;

          &:hover {
            background: #40a9ff;
            border-color: #40a9ff;
          }
        }
      }
    }
  }
}

/* 客户评价样式 */
.customer-testimonials {
  padding: 100px 0;

  .section-title {
    text-align: center;
    margin-bottom: 60px;

    h2 {
      font-size: 36px;
      color: #333;
      margin-bottom: 15px;
      position: relative;
      display: inline-block;

      &::after {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 80px;
        height: 3px;
        background: #1890ff;
      }
    }

    p {
      font-size: 18px;
      color: #666;
    }
  }

  .testimonials-slider {
    .el-carousel {
      .el-carousel__item {
        background: #fff;
        border-radius: 12px;
        padding: 40px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);

        .testimonial-content {
          height: 100%;
          display: flex;
          flex-direction: column;

          .testimonial-text {
            font-size: 16px;
            color: #666;
            line-height: 1.8;
            font-style: italic;
            margin-bottom: 30px;
            flex: 1;
            position: relative;
            padding: 0 30px;

            &::before,
            &::after {
              content: '"';
              position: absolute;
              font-size: 60px;
              color: #e6f7ff;
              font-weight: bold;
              line-height: 1;
            }

            &::before {
              top: -20px;
              left: 0;
            }

            &::after {
              bottom: -40px;
              right: 0;
            }
          }

          .testimonial-author {
            display: flex;
            align-items: center;
            gap: 20px;
            margin-top: 20px;

            img {
              width: 80px;
              height: 80px;
              border-radius: 50%;
              object-fit: cover;
            }

            .author-info {
              h4 {
                font-size: 18px;
                color: #333;
                margin-bottom: 5px;
                font-weight: 600;
              }

              p {
                font-size: 14px;
                color: #999;
              }
            }
          }
        }
      }

      .el-carousel__arrow {
        background: #1890ff;
        opacity: 0.8;

        &:hover {
          opacity: 1;
          background: #1890ff;
        }
      }
    }
  }
}

/* 合作咨询样式 */
.cooperation-consult {
  padding: 80px 0;
  background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
  color: #fff;

  .consult-content {
    text-align: center;
    max-width: 800px;
    margin: 0 auto;

    h2 {
      font-size: 32px;
      margin-bottom: 20px;
      font-weight: 600;
    }

    p {
      font-size: 18px;
      margin-bottom: 30px;
      opacity: 0.9;
    }

    .el-button {
      background: #fff;
      color: #1890ff;
      border-color: #fff;
      padding: 12px 36px;
      font-size: 18px;

      &:hover {
        background: #e6f7ff;
        color: #1890ff;
        border-color: #e6f7ff;
      }
    }
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    width: 100%;
    padding: 0 30px;
  }

  .cases-showcase {
    .cases-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .case-analysis {
    .analysis-content {
      .analysis-item {
        .analysis-image {
          height: 350px;
        }

        .analysis-text {
          padding: 40px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .page-title {
    padding: 80px 0;

    h1 {
      font-size: 36px;
    }

    p {
      font-size: 18px;
    }
  }

  .industry-filter {
    .filter-tabs {
      .el-tabs__header {
        .el-tabs__nav {
          .el-tabs__item {
            padding: 0 15px;
            font-size: 14px;
          }
        }
      }
    }
  }

  .cases-showcase {
    padding: 60px 0;

    .cases-grid {
      grid-template-columns: 1fr;
      gap: 20px;
    }

    .case-card {
      .case-image {
        height: 180px;
      }

      .case-info {
        padding: 20px;
      }
    }
  }

  .case-analysis {
    padding: 80px 0;

    .section-title {
      h2 {
        font-size: 28px;
      }

      p {
        font-size: 16px;
      }
    }

    .analysis-content {
      .analysis-item {
        flex-direction: column;

        .analysis-image {
          flex: 0 0 auto;
          height: 250px;
        }

        .analysis-text {
          padding: 30px;

          h3 {
            font-size: 24px;
          }
        }
      }
    }
  }

  .customer-testimonials {
    padding: 80px 0;

    .section-title {
      h2 {
        font-size: 28px;
      }

      p {
        font-size: 16px;
      }
    }

    .testimonials-slider {
      .el-carousel {
        .el-carousel__item {
          padding: 30px 20px;

          .testimonial-content {
            .testimonial-text {
              padding: 0 20px;
            }

            .testimonial-author {
              flex-direction: column;
              text-align: center;
            }
          }
        }
      }
    }
  }

  .cooperation-consult {
    padding: 60px 0;

    .consult-content {
      h2 {
        font-size: 28px;
      }

      p {
        font-size: 16px;
      }

      .el-button {
        padding: 10px 30px;
        font-size: 16px;
      }
    }
  }
}
</style>
